import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'fold-card-wrapper',
  templateUrl: './fold-card-wrapper.component.html',
  styleUrl: './fold-card-wrapper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FoldCardWrapperComponent extends FieldWrapper {
  collapsed: boolean;
}
